import testingAPI from './testingAPI';
import DirectionalRecord from '@utils/recordClasses/directionalRecord';

import MAP_CONSTANTS from '../constants/map.json';

class TestGUI {
  constructor() {
    this.currentTest = null;
    this.testState = {};
    this.testState.init = function(testName) {
      for (let _loc2 in this) {
        if (_loc2 !== 'init') {
          delete this[_loc2];
        }
      }
      this.x = null;
      this.y = null;
      this.testCounter = 0;
      switch (testName) {
        case 'drilling':
          this.z = null;
          this.method = null;
          break;
        case 'gpr':
          this.coords = null;
          this.x2 = null;
          this.y2 = null;
          break;

        case 'exca':
        case 'mmd':
        case 'sgsa':
        case 'topo':
          break;

        case 'srr':
          this.coords = null;
          this.x2 = null;
          this.y2 = null;
          break;
        default:
      }
    };
    this.srrMaxDistance = MAP_CONSTANTS.markerParams.srrMaxDistance;
    this.gprMaxDistance = MAP_CONSTANTS.markerParams.gprMaxDistance;
    this.testPanels = {};

    this.displayedResults = [];
  }

  setDataStore(dataStore) {
    this.dataStore = dataStore;
  }

  setup(testName) {
    this.currentTest = testName;
    this.eraseResults();
  }

  setStateCoords(x, y) {
    this.testState.x = x;
    this.testState.y = y;
  }

  drillButtonCB(launchPopup) {
    if (this.testState.method === 'push') {
      this.testState.testCounter = 0;
    }
    this.testState.method = 'drill';
    this.drilling(launchPopup);
  }

  pushButtonCB(launchPopup) {
    if (this.testState.method === 'drill') {
      this.testState.testCounter = 0;
    }
    this.testState.method = 'push';
    this.drilling(launchPopup);
  }

  eraseResults() {
    this.displayedResults = [];
  }
  pushResultsTxt() {
    let resTxt = this.displayResults();
    if (
      this.displayedResults.length > 0 &&
      resTxt === this.displayedResults[this.displayedResults.length - 1]
    )
      return;
    if (resTxt) this.displayedResults.push(resTxt);
    else {
      if (this.currentTest !== 'topo') {
        this.eraseResults();
      }
    }
  }

  onStartingPointSelect(x, y) {
    this.testState.x = x;
    this.testState.y = y;

    /*if (!this.validateTest()) {
      return;
    }
    if (this.currentTest === 'gpr') {
      if (!(this.validateTest(this.testState.x2, this.testState.y2) && this.validateGpr())) {
        return;
      }
    } else if (this.currentTest === 'srr' || this.currentTest === 'mmd') {
      if (!(this.validateTest(this.testState.x2, this.testState.y2) && this.validateSrr())) {
        return;
      }
    }*/
    if (!this.completeValidation()) {
      return;
    }

    if (this.currentTest === 'drilling') {
      this.testState.geoData = testingAPI.drill(
        this.testState.x / 10,
        this.testState.y / 10,
      );
    } else if (this.currentTest === 'gpr' || this.currentTest === 'mmd') {
      this.testState.testCounter = 0;
    }
    if (this.currentTest !== 'topo') this.eraseResults();
    this.pushResultsTxt();
  }
  onEndingPointSelect(x, y) {
    this.testState.x2 = x;
    this.testState.y2 = y;

    if (!this.completeValidation()) {
      return;
    }

    this.eraseResults();
    this.pushResultsTxt();
  }

  validateTest(x, y) {
    let testX = typeof x === 'undefined' ? this.testState.x : x;
    let testY = typeof x === 'undefined' ? this.testState.y : y;

    return !(
      testX === null ||
      testY === null ||
      testX % 10 !== 0 ||
      testY % 10 !== 0
    );
  }

  validateGpr(testX, testY, testX2, testY2) {
    let errMsg = null;
    if (
      Math.max(Math.abs(testX2 - testX), Math.abs(testY2 - testY)) >
      this.gprMaxDistance
    ) {
      errMsg = 'error_too_far_100';
    } else if (testX2 !== testX && testY2 !== testY) {
      errMsg = 'error_not_aligned';
    } else if (testX === testX2 && testY === testY2) {
      errMsg = 'error_too_short';
    }

    return !errMsg;
  }

  validateSrr(testX, testY, testX2, testY2) {
    let errMsg = null;
    if (
      Math.max(Math.abs(testX2 - testX), Math.abs(testY2 - testY)) >
      this.srrMaxDistance
    ) {
      errMsg = 'error_too_far_230';
    }
    if (testX2 !== testX && testY2 !== testY) {
      errMsg = 'error_not_aligned';
    } else if (testX === testX2 && testY === testY2) {
      errMsg = 'error_too_short';
    }

    return !errMsg;
  }
  completeValidation() {
    if (!this.validateTest()) {
      return false;
    }
    if (this.testState.x < 0 || this.testState.x > MAP_CONSTANTS.main.width || this.testState.y < 0 || this.testState.y > MAP_CONSTANTS.main.height) {
      return false;
    }
    if (this.currentTest === 'gpr') {
      if (!(this.validateTest(this.testState.x2, this.testState.y2) && this.validateGpr(this.testState.x, this.testState.y, this.testState.x2, this.testState.y2))) {
        return false;
      }
    } else if (this.currentTest === 'srr' || this.currentTest === 'mmd') {
      if (!(this.validateTest(this.testState.x2, this.testState.y2) && this.validateSrr(this.testState.x, this.testState.y, this.testState.x2, this.testState.y2))) {
        return false;
      }
    }
    return true;
  }

  performTest(updateCallback, launchPopup, erasePrev = true) {
    let testX = this.testState.x;
    let testY = this.testState.y;
    let i;
    let testCoordX;
    let testCoordY;
    let price;
    let errMsg;
    let testX2;
    let testY2;
    let resultData;

    if (!this.validateTest()) {
      launchPopup('error_drill_invalid');
      return;
    }

    switch (this.currentTest) {
      case 'exca':
        if (
          typeof this.dataStore.getTestData('exca', testX, testY) ===
          'undefined'
        ) {
          resultData = testingAPI[this.currentTest](testX / 10, testY / 10);
          if (resultData === 'background') {
            resultData =
              testingAPI.loess(testX / 10, testY / 10) + 'ft of loess.';
          }
          this.dataStore.savePerformedTest('exca', testX, testY, 1500, true, resultData);
        }
        break;
      case 'gpr':
        testX2 = this.testState.x2;
        testY2 = this.testState.y2;
        if (
          Math.max(Math.abs(testX2 - testX), Math.abs(testY2 - testY)) >
          this.gprMaxDistance
        ) {
          errMsg = 'error_too_far_100';
        } else if (testX2 !== testX && testY2 !== testY) {
          errMsg = 'error_not_aligned';
        } else if (testX === testX2 && testY === testY2) {
          errMsg = 'error_too_short';
        }
        if (typeof errMsg !== 'undefined') {
          launchPopup(errMsg);
          return;
        }
        var testCoords = this.testState.coords;
        var testCoordsX = testCoords.x;
        var testCoordsY = testCoords.y;
        var testDirection = testCoords.direction;
        price = 125;

        for (i = 0; i < testCoordsX.length - 1; i++) {
          testCoordX = testCoordsX[i];
          testCoordY = testCoordsY[i];
          let testGprData = this.dataStore.getTestData(
            'gpr',
            testCoordX,
            testCoordY,
          );
          if (testGprData[testDirection] !== 1) {
            testGprData.update(testDirection);

            resultData = testingAPI.gpr(testCoordX / 10, testCoordY / 10, testDirection);

            this.dataStore.savePerformedTest(
              'gpr',
              testCoordX,
              testCoordY,
              price,
              testGprData,
              resultData
            );
            price = 25;
          }
        }
        updateCallback();
        break;
      case 'mmd':
        if (
          typeof this.dataStore.getTestData('mmd', testX, testY) === 'undefined'
        ) {
          price = 20;
          if (this.testState.testCounter % 40 === 0) {
            price = 200;
          }
          resultData = testingAPI[this.currentTest](testX / 10, testY / 10);
          this.dataStore.savePerformedTest('mmd', testX, testY, price, true, resultData);
          this.testState.testCounter++;
        }
        break;
      case 'sgsa':
        if (
          typeof this.dataStore.getTestData('sgsa', testX, testY) ===
          'undefined'
        ) {
          resultData = testingAPI[this.currentTest](testX / 10, testY / 10);
          let units = testingAPI[this.currentTest].units;
          if (typeof units !== 'undefined') {
            resultData += ' ' + units;
          }
          this.dataStore.savePerformedTest('sgsa', testX, testY, 215, true, resultData);
        }
        break;
      case 'srr':
        testX2 = this.testState.x2;
        testY2 = this.testState.y2;

        if (
          Math.max(Math.abs(testX2 - testX), Math.abs(testY2 - testY)) >
          this.srrMaxDistance
        ) {
          errMsg = 'error_too_far_230';
        }
        if (testX2 !== testX && testY2 !== testY) {
          errMsg = 'error_not_aligned';
        } else if (testX === testX2 && testY === testY2) {
          errMsg = 'error_too_short';
        }
        if (typeof errMsg !== 'undefined') {
          launchPopup(errMsg);
          return;
        }
        testCoords = this.testState.coords;
        testCoordsX = testCoords.x;
        testCoordsY = testCoords.y;
        price = 670;
        for (i = 0; i < testCoordsX.length; i++) {
          testCoordX = testCoordsX[i];
          testCoordY = testCoordsY[i];
          if (
            typeof this.dataStore.getTestData('srr', testCoordX, testCoordY) ===
            'undefined'
          ) {
            this.dataStore.savePerformedTest(
              'srr',
              testCoordX,
              testCoordY,
              price,
              true,
              testingAPI.srr(testCoordX / 10, testCoordY / 10) + ' ' + testingAPI.srr.units
            );
            price = 0;
          }
        }
        updateCallback();
        break;
      case 'topo':
        if (
          typeof this.dataStore.getTestData('topo', testX, testY) ===
          'undefined'
        ) {
          price = 20;
          if (this.testState.testCounter % 20 === 0) {
            price = 320;
          }
          this.dataStore.savePerformedTest(
            'topo',
            testX,
            testY,
            price,
            true,
            testingAPI[this.currentTest](testX / 10, testY / 10) + ' ' + testingAPI.topo.units
          );
          this.testState.testCounter++;
        }
        break;
      default:
    }
    if (this.currentTest !== 'srr' && this.currentTest !== 'gpr') {
      updateCallback();
    }
    if (erasePrev && this.currentTest !== 'topo') {
      this.eraseResults();
    }
    this.pushResultsTxt();
  }

  analysis(launchPopup, elevation) {
    if (
      this.testState.x === null ||
      this.testState.y === null ||
      this.testState.x % 10 !== 0 ||
      this.testState.y % 10 !== 0
    ) {
      launchPopup('error_drill_invalid');
      return false;
    }
    let testMethod = this.testState.method;

    if (elevation !== null) {
      var testDataRecord = this.dataStore.getTestData(
        'analysis',
        this.testState.x,
        this.testState.y,
      );
      var testData = testingAPI.sampleAnalysis(
        this.testState.x / 10,
        this.testState.y / 10,
        elevation,
        testMethod,
      );
      testDataRecord.update(testMethod, elevation, testData);
      var price = this.dataStore.analysisInfo[testMethod].cost;
      this.dataStore.savePerformedTest(
        'analysis',
        this.testState.x,
        this.testState.y,
        price,
        testDataRecord,
      );
    }
    //launchDBox(analysisDBoxBuilder, null);
    launchPopup('analysis');
  }

  buildElevationArray(min, max) {
    var result = [];
    if ((min || min === 0) && (max || max === 0)) {
      for (let i = min; i <= max; i += 10) {
        result.push(i);
      }
    }
    return result;
  }

  drilling(launchPopup, elevation) {
    if (
      this.testState.x === null ||
      this.testState.y === null ||
      this.testState.x % 10 !== 0 ||
      this.testState.y % 10 !== 0
    ) {
      launchPopup('error_drill_invalid');
      //launchDBox(errorDBoxBuilder, ["You have entered invalid coordinates. Please enter coordinates which are multiples of ten."]);
      return false;
    }

    let testDataRecordWell = this.dataStore.getTestData(
      'well',
      this.testState.x,
      this.testState.y,
    );
    if (testDataRecordWell && testDataRecordWell.numWells > 9) {
      launchPopup('error_drill_exhaustion');
      //launchDBox(errorDBoxBuilder, ["You may not drill any more holes at this location. Please try again at different coordinates."]);
      return false;
    }

    let basePrice = 0;
    if (this.testState.method === 'push') {
      if (this.testState.testCounter % 10 === 0) {
        basePrice = 2000;
      }
    } else if (this.testState.testCounter % 2 === 0) {
      basePrice = 2000;
    }
    let additionalPrice = this.testState.method === 'push' ? 0 : 50;
    let completivePrice = 25;
    let foundation = 'temp';
    let foundationElevation = elevation;
    let price;
    let testGeoData;
    let testDataDrilling;
    if (typeof elevation === 'undefined') {
      testGeoData = this.testState.geoData;
      foundationElevation = testGeoData.waterTable;
      elevation = Math.floor(foundationElevation / 10) * 10;
      foundation = 'waterTable';
      price = Math.floor(
        basePrice +
          (testGeoData.surface - elevation) * additionalPrice +
          completivePrice,
      );
      testDataDrilling = this.dataStore.getTestData(
        'drilling',
        this.testState.x,
        this.testState.y,
      );
      if (testDataDrilling.latestMethod === null) {
        //mapObj.drawGridSquare(this.testState.x, this.testState.y, "oldData");
      }
      testDataDrilling.update(elevation, this.testState.method);
      this.dataStore.savePerformedTest(
        'drilling',
        this.testState.x,
        this.testState.y,
        price,
        testDataDrilling,
      );
      this.testState.testCounter++;
    } else {
      testGeoData = this.testState.geoData;
      if (elevation <= testGeoData.bedrock) {
        foundationElevation = testGeoData.bedrock;
        elevation = Math.ceil(foundationElevation / 10) * 10;
        foundation = 'bedrock';
      }
      price = Math.floor(
        (this.testState.z - elevation) *
          (additionalPrice + completivePrice / 10),
      );
      testDataDrilling = this.dataStore.getTestData(
        'drilling',
        this.testState.x,
        this.testState.y,
      );
      testDataDrilling.update(elevation, this.testState.method);
      this.dataStore.savePerformedTest(
        'drilling',
        this.testState.x,
        this.testState.y,
        price,
        testDataDrilling,
      );
    }
    this.testState.z = elevation;
    //this.displayResults();
    this.eraseResults();
    this.pushResultsTxt();
    //launchDBox(drillingDBoxBuilder, [foundation, foundationElevation]);
    launchPopup(foundation);
  }

  installWell(elevation) {
    var price = 500;
    var testDataWell = this.dataStore.getTestData(
      'well',
      this.testState.x,
      this.testState.y,
    );
    if (testDataWell.containsWellScreen(elevation)) {
      return;
    }
    testDataWell.update(elevation);
    this.dataStore.savePerformedTest(
      'well',
      this.testState.x,
      this.testState.y,
      price,
      testDataWell,
    );
    this.eraseResults();
    this.pushResultsTxt();
    //this.displayResults();
  }

  getTransectCoords() {
    let testX = this.testState.x;
    let testY = this.testState.y;
    let testX2 = this.testState.x2;
    let testY2 = this.testState.y2;
    let direction = null;
    let maxDistance =
      this.currentTest === 'srr' ? this.srrMaxDistance : this.gprMaxDistance;
    let xCoords = [testX];
    let yCoords = [testY];
    let deltaX = testX2 - testX;
    let deltaY = testY2 - testY;
    let directedDelta;
    if (deltaX === 0 && deltaY !== 0) {
      if (testY2 > testY) {
        direction = 'n';
        if (deltaY > maxDistance) {
          deltaY = maxDistance;
          testY2 = testY + maxDistance;
        }
      } else {
        direction = 's';
        if (deltaY < -maxDistance) {
          deltaY = -maxDistance;
          testY2 = testY - maxDistance;
        }
      }
      directedDelta = (10 * deltaY) / Math.abs(deltaY);
      for (var y = testY + directedDelta; y !== testY2; y += directedDelta) {
        yCoords.push(y);
        xCoords.push(testX);
      }
    } else if (deltaY === 0 && deltaX !== 0) {
      if (testX2 > testX) {
        direction = 'e';
        if (deltaX > maxDistance) {
          deltaX = maxDistance;
          testX2 = testX + maxDistance;
        }
      } else {
        direction = 'w';
        if (deltaX < -maxDistance) {
          deltaX = -maxDistance;
          testX2 = testX - maxDistance;
        }
      }
      directedDelta = (10 * deltaX) / Math.abs(deltaX);
      for (let x = testX + directedDelta; x !== testX2; x += directedDelta) {
        xCoords.push(x);
        yCoords.push(testY);
      }
    }
    if (typeof testX2 !== 'undefined') {
      xCoords.push(testX2);
      yCoords.push(testY2);
    }
    return { x: xCoords, y: yCoords, direction: direction };
  }

  displayResults(erase) {
    let testX = this.testState.x;
    let testY = this.testState.y;
    if (
      typeof testX === 'undefined' ||
      typeof testY === 'undefined' ||
      testX === null ||
      testY === null
    ) {
      //this.displayedResults = [];
      return '';
    }
    let currentTest = this.currentTest;
    let testData = this.dataStore.getTestData(currentTest, testX, testY);
    let resultsTxt = '';
    let i;
    if (currentTest === 'drilling') {
      if (erase) {
        return '';
      }
      let testGeoData = this.testState.geoData;
      let testDataWell = this.dataStore.getTestData('well', testX, testY);
      let surfaceElevation = '???';
      let waterTableElevation = '??? (install well at water table)';
      let floatingGasThickness = '??? (install well at water table)';
      let bedrockElevation = '???';
      let numWells = testDataWell.numWells;
      if (numWells === null) {
        numWells = 0;
      }
      let wellScreenElevations = '(none)';
      if (testData.deepestDrilled !== null || testData.deepestPushed !== null) {
        surfaceElevation = testGeoData.surface + 'ft';
        for (let screen in testDataWell.wellScreens) {
          if (testGeoData.waterTable - testDataWell.wellScreens[screen] < 10) {
            floatingGasThickness =
              testGeoData.floatingGasThickness + 'ft thick';
            waterTableElevation = testGeoData.waterTable + 'ft';
          }
          wellScreenElevations += testDataWell.wellScreens[screen] + 'ft, ';
        }
        if (wellScreenElevations !== '(none)') {
          wellScreenElevations = wellScreenElevations.substring(
            6,
            wellScreenElevations.length - 2,
          );
        }
        if (testData.deepestDrilled - testGeoData.bedrock < 10) {
          bedrockElevation = testData.deepestDrilled + 'ft';
        }
      }
      resultsTxt = 'Surface elevation (' + testX + ', ' + testY + '): ' + surfaceElevation + '\r';
      resultsTxt += 'Water table: ' + waterTableElevation + '\r';
      resultsTxt += 'Floating gas: ' + floatingGasThickness + '\r';
      resultsTxt +=
        'Bedrock elevation (approximate): ' + bedrockElevation + '\r';
      resultsTxt += 'Number of wells (max 10 per square): ' + numWells + '\r';
      resultsTxt += 'Well screen elevations: ' + wellScreenElevations;
    } else if (currentTest === 'gpr' || currentTest === 'srr') {
      let data;
      if (erase) {
        return '';
      }
      var transectCoords = this.getTransectCoords();
      this.testState.coords = transectCoords;
      var transectX = transectCoords.x;
      var transectY = transectCoords.y;
      let x, y;
      if (currentTest === 'srr') {
        for (i = 0; i < transectX.length; i++) {
          data = '?';
          x = transectX[i];
          y = transectY[i];
          var testDataSrr = this.dataStore.getTestData('srr', x, y);
          if (typeof testDataSrr !== 'undefined') {
            data = testingAPI.srr(x / 10, y / 10) + ' ' + testingAPI.srr.units;
          }
          resultsTxt += '(' + x + ', ' + y + '): ' + data + '\n';
        }
      } else if (currentTest === 'gpr') {
        if (transectCoords.direction !== null) {
          let direction = transectCoords.direction;
          let coordDelta = DirectionalRecord.coordDelta(direction);
          let deltaX = 10 * coordDelta.x;
          let deltaY = 10 * coordDelta.y;
          for (i = 0; i < transectX.length - 1; i++) {
            data = '?';
            x = transectX[i];
            y = transectY[i];
            let testDataGpr = this.dataStore.getTestData('gpr', x, y);
            if (testDataGpr[direction] === 1) {
              data = testingAPI.gpr(x / 10, y / 10, direction);
            } else {
              var testDataGprDelta = this.dataStore.getTestData(
                'gpr',
                x + deltaX,
                y + deltaY,
              );
              if (
                testDataGprDelta[
                  DirectionalRecord.oppositeDirection(direction)
                ] === 1
              ) {
                data = testingAPI.gpr(x / 10, y / 10, direction);
              }
            }
            resultsTxt += '(' + x + ', ' + y + '): ' + data + '\n';
          }
        }
      }
    } else if (currentTest === 'mmd') {
      if (erase) {
        return '';
      }
      if (typeof testData !== 'undefined') {
        let testDataMmd = testingAPI[currentTest](testX / 10, testY / 10);
        resultsTxt += '(' + testX + ', ' + testY + '): ' + testDataMmd + '\n';
      }
    } else if (currentTest === 'exca') {
      if (typeof testData === 'undefined' || erase === true) {
        resultsTxt = '';
      } else {
        let testDataExca = testingAPI[currentTest](testX / 10, testY / 10);
        if (testDataExca === 'background') {
          testDataExca =
            testingAPI.loess(testX / 10, testY / 10) + 'ft of loess.';
        }
        resultsTxt = '(' + testX + ', ' + testY + '): ' + testDataExca;
        let units = testingAPI[currentTest].units;
        if (typeof units !== 'undefined') {
          resultsTxt += ' ' + units;
        }
      }
    } else {
      if (typeof testData === 'undefined' || erase === true) {
        resultsTxt = '';
      } else {
        let testDataOther = testingAPI[currentTest](testX / 10, testY / 10);
        resultsTxt = '(' + testX + ', ' + testY + '): ' + testDataOther;
        let units = testingAPI[currentTest].units;
        if (typeof units !== 'undefined') {
          resultsTxt += ' ' + units;
        }
      }
    }
    //this.displayedResults.push(resultsTxt);
    return resultsTxt;
    //navObj.updateBalance();
  }

  getResults(testName, x, y) {
    var result = '';
    var testData = this.dataStore.getTestData(testName, x, y);
    if (testName === 'drilling') {
      var drillResults = testingAPI.drill(x / 10, y / 10);
      var testDataWell = this.dataStore.getTestData('well', x, y);
      var surfaceElevation = '???';
      var waterTableElevation = '??? (install well at water table)';
      var floatingGasThickness = '??? (install well at water table)';
      var bedrockElevation = '???';
      var numWells = testDataWell.numWells;
      if (!numWells) {
        numWells = 0;
      }
      var wellScreenElevations = '(none)';
      if (
        (testData.deepestDrilled !== 0 && testData.deepestDrilled) ||
        testData.deepestPushed !== null
      ) {
        surfaceElevation = drillResults.surface + 'ft';
        for (let screen in testDataWell.wellScreens) {
          if (drillResults.waterTable - testDataWell.wellScreens[screen] < 10) {
            floatingGasThickness =
              drillResults.floatingGasThickness + 'ft thick';
            waterTableElevation = drillResults.waterTable + 'ft';
          }
          wellScreenElevations =
            wellScreenElevations + (testDataWell.wellScreens[screen] + 'ft, ');
        }
        if (wellScreenElevations !== '(none)') {
          wellScreenElevations = wellScreenElevations.substring(
            6,
            wellScreenElevations.length - 2,
          );
        }
        if (testData.deepestDrilled - drillResults.bedrock < 10) {
          bedrockElevation = testData.deepestDrilled + 'ft';
        }
      }
      result = 'Surface elevation (' + x + ', ' + y + '): ' + surfaceElevation + '\r';
      result += 'Water table: ' + waterTableElevation + '\r';
      result += 'Floating gas: ' + floatingGasThickness + '\r';
      result += 'Bedrock elevation (approximate): ' + bedrockElevation + '\r';
      result += 'Number of wells (max 10 per square): ' + numWells + '\r';
      result += 'Well screen elevations: ' + wellScreenElevations;
    } else if (testName === 'exca' && typeof testData !== 'undefined') {
      let data = testingAPI[testName](x / 10, y / 10);
      if (data === 'background') {
        data = testingAPI.loess(x / 10, y / 10) + 'ft of loess.';
      }
      result = '(' + x + ', ' + y + '): ' + data;
      var units = testingAPI[testName].units;
      if (typeof units !== 'undefined') {
        result += ' ' + units;
      }
    } else if (testName === 'gpr' && typeof testData !== 'undefined') {
      let data = testingAPI.gpr(x / 10, y / 10, testData + '');
      result = '(' + x + ', ' + y + '): ' + data;
      units = testingAPI[testName].units;
      if (typeof units !== 'undefined') {
        result += ' ' + units;
      }
    } else if (typeof testData !== 'undefined') {
      let data = testingAPI[testName](x / 10, y / 10);
      result = '(' + x + ', ' + y + '): ' + data;
      units = testingAPI[testName].units;
      if (typeof units !== 'undefined') {
        result += ' ' + units;
      }
    }
    return result;
  }
}

export default new TestGUI();
